import { render, staticRenderFns } from "./SiderContainer.vue?vue&type=template&id=0906d86c"
import script from "./SiderContainer.vue?vue&type=script&lang=ts"
export * from "./SiderContainer.vue?vue&type=script&lang=ts"
import style0 from "./SiderContainer.vue?vue&type=style&index=0&id=0906d86c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports